import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CalendarServiceDetailService {
 
  constructor(private apiSvc: ApiService) { }
 
  public getService(Id: string, LectionaryYear: string, DailyOfficeLectionaryYear: string, LiturgyType: number, LiturgicalDate: string): Promise<any> {

    var payload = {
      ServiceId: Id,
      LectionaryYear: LectionaryYear,
      DailyOfficeLectionaryYear: DailyOfficeLectionaryYear,
      LiturgyType: LiturgyType,
      Date: LiturgicalDate
    }

    const p = new Promise<any>((resolve, reject) => { 
      this.apiSvc.post("api/CalendarServiceDetail/GetService/", payload).subscribe(
        (data: any) => {
          console.log("CalendarServiceDetail/GetService", data);
          resolve(data);
        },
        (err) => {
          console.log("error", err);
          var errStr = "Error: cannot retreive service at this time.";
          errStr += "\n" + JSON.parse(err._body).ExceptionMessage;
          alert(errStr);
          reject(err);
        }
      );

    });

    return p;
  }
 
  public getAvailableServices(Date: any, LiturgyType: number): Promise<any> {

    var dateStr = Date.DateMonth + "/" + Date.DateDay + "/" + Date.DateYear;
    //This should be reconsidered for moving to the API. The client app should not have the logic for determining liturgy type mappings 
    var payload = {
      Date: dateStr,
      LiturgyTypeEnum: LiturgyType
    }; 
 
    const p = new Promise<any>((resolve, reject) => { 
      this.apiSvc.post("api/CalendarServiceDetail/GetAvailableServicesForLiturgyType/", payload).subscribe(
        (s: any[any]) => {
   
          console.log(s);
          //this.isLoadingData = false;
          resolve(s);
        },
        (err) => {
          console.log(err);
          alert(err); 
          reject(err);
        }
      );
    });

    return p;
  }
 
}